<template>
<section
  :style="imgObj ? `background-image:url(${imgHost}${imgObj[fileProp]}${/data/.test(imgHost) ? '' : `?ts=${new Date().getTime()}`})` : ''"
  class="check-item-img-display"
  @click="onClick"
>
  <div
    v-if="!imgObj"
    class="add-image-btn"
  >+</div>
  <label v-if="isNet && !imgObj" style="position:absolute;top:0;left:0;width:100%;height:100%;">
    <input
      ref="fileInput"
      type="file"
      accept="image/*"
      style="opacity:0;"
      @change="onFileChange"
    />
  </label>
</section>
</template>

<script>
const MAX_WIDTH = 800
const MAX_HEIGHT = 600

const takePhoto = () => new Promise((resolve, reject) => {
  let camera = window.plus.camera.getCamera()
  camera.captureImage(resolve, reject, {filename: '_doc/camera/', index: 1})
})

const dealImage = (path, obj, callback) => {
  let img = new Image()
  img.crossOrigin = 'Anonymous'
  img.src = path
  img.onload = function () {
    let w = this.width
    let h = this.height
    let scale = w / h

    if (w >= h) {
      w = obj.width
      h = w / scale
    } else {
      h = obj.height
      w = h * scale
    }

    let quality = 0.9
    let canvas = document.createElement('canvas')
    let ctx = canvas.getContext('2d')
    let anw = document.createAttribute('width')
    anw.nodeValue = w
    let anh = document.createAttribute('height')
    anh.nodeValue = h
    canvas.setAttributeNode(anw)
    canvas.setAttributeNode(anh)
    ctx.drawImage(this, 0, 0, w, h)
    // 图像质量
    if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
      quality = obj.quality
    }
    let base64 = canvas.toDataURL('image/jpeg', quality)
    callback(base64)
  }
}

const blobToDataURL = (blob, cb) => {
  let reader = new FileReader()
  reader.onload = function (evt) {
    let base64 = evt.target.result
    cb(base64)
  }
  reader.readAsDataURL(blob)
}

export default {
  name: 'DataImage',
  props: {
    imgHost: {
      required: true,
      type: String
    },
    imgObj: {
      type: Object
    },
    fileProp: {
      type: String,
      default: 'pictureFile'
    }
  },
  data () {
    return {
      imgOptVisible: false,
      uploadFile: ''
    }
  },
  computed: {
    isNet () {
      return /^https?:$/.test(location.protocol)
    }
  },
  methods: {
    onClick (event) {
      let imgObj = this.imgObj

      if (imgObj) {
        return this.$emit('img-click', imgObj)
      }

      if (this.isNet) {
        return
      }

      takePhoto(event).then(path => new Promise((resolve, reject) => window.plus.io.resolveLocalFileSystemURL(path, resolve))).then(entry => {
        dealImage(entry.toLocalURL(), {
          width: Math.min(screen.width, MAX_WIDTH),
          height: Math.min(screen.height, MAX_HEIGHT),
          quality: 1
        }, base64 => {
          this.$emit('take-photo', base64)
        })
      })
    },
    onFileChange (event) {
      let fileInput = event.target
      let file = fileInput.files[0]
      // let type = file.type

      blobToDataURL(file, base64 => {
        // this.$emit('take-photo', base64)
        dealImage(base64, {
          width: Math.min(screen.width, MAX_WIDTH),
          height: Math.min(screen.height, MAX_HEIGHT),
          quality: 1
        }, base64 => {
          this.$emit('take-photo', base64)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.check-item-img-display {
  border: 1px dashed #cfd0d3 {
    radius: 10px;
  };
  background: {
    size: cover;
    position: center;
    repeat: no-repeat;
  };
  overflow: hidden;

  .add-image-btn {
    position: absolute;
    font-size: 30px;
    top: 50%;
    left: 50%;
    color: #cfd0d3;
    transform: translate(-50%, -50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Data/Image/index.vue